function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

export function stripFlowElement(el) {
  return /^(p|h[1-6])$/.test(el) ? 'span' : el;
} // TODO: can we refactor this to not look that ugly?

export function arrayifyResponsiveValue(value) {
  if (_typeof(value) === 'object') {
    if (!Array.isArray(value)) {
      var _defaultValue = value.default,
          _fromM = value.fromM,
          _fromL = value.fromL,
          _fromXL = value.fromXL;
      return [_defaultValue, _fromM, _fromL, _fromXL];
    }

    var _value = _slicedToArray(value, 4),
        defaultValue = _value[0],
        fromM = _value[1],
        fromL = _value[2],
        fromXL = _value[3];

    return [defaultValue, fromM, fromL, fromXL];
  }

  return [value, value, value, value];
}
export function populateResponsiveArray(value) {
  return value.reduce(function (filled, item, index) {
    return [].concat(_toConsumableArray(filled), [item || filled[index - 1]]);
  }, []);
}
export function normalizeResponsiveValue(value) {
  return populateResponsiveArray(arrayifyResponsiveValue(value));
}
export function getBaseStyle() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // eslint-disable-next-line
  var fromM = style.fromM,
      fromL = style.fromL,
      fromXL = style.fromXL,
      baseStyle = _objectWithoutProperties(style, ["fromM", "fromL", "fromXL"]);

  return baseStyle;
}
var breakpoints = ['fromM', 'fromL', 'fromXL'];
export function getStylesForEachBreakpoint(styles, breakpoint) {
  var breakpointSpan = breakpoints.indexOf(breakpoint) + 1;
  return breakpoints.slice(0, breakpointSpan).reduce(function (mergedStyles, breakpoint) {
    if (styles[breakpoint]) {
      return _objectSpread(_objectSpread({}, mergedStyles), styles[breakpoint]);
    }

    return mergedStyles;
  }, {});
}
export function mergeStyles(_ref, subStyle, breakpoint) {
  var styles = _ref.standard.styles,
      subStyles = _objectWithoutProperties(_ref, ["standard"]);

  var baseStyle = getBaseStyle(styles);
  var baseSubStyle = getBaseStyle(subStyles[subStyle] ? subStyles[subStyle].styles : {});
  return _objectSpread(_objectSpread(_objectSpread({}, baseStyle), baseSubStyle), getStylesForEachBreakpoint(styles, breakpoint));
}
export function getRenderedElement(isRootElement, as, variant, subStyle, theme) {
  var defaultElement = as || typeof variant === 'string' && typeof subStyle === 'string' && theme.typeScale[variant][subStyle] && theme.typeScale[variant][subStyle].element || 'p';
  return isRootElement ? defaultElement : stripFlowElement(defaultElement);
}